<template>
  <div class="wrapper">
    <GameCharts />
  </div>
</template>

<script>
import GameCharts from "../components/GameCharts";
export default {
  components: {
    GameCharts
  }
};
</script>

<style scoped>
.wrapper {
  padding: 40px 10px;
}
</style>
